/*
 * 0.68: Wert eines eigenen Felds an einer Karte setzen – sofort anzeigen, ohne Verbindung über die Outbox mit
 * Prüfung des gesehenen Werts (0.46). Gemeinsam für Kartendetails und Kalender.
 */
import type { QueryClient } from '@tanstack/react-query';
import type { BoardSnapshot, CardDetail, CardSummary, CustomField } from '@kaba/shared';
import { api, newOpId } from './api';
import { boardKey, cardKey, sendOrQueue, upsertCards } from './board';
import { toast } from './toast';

export async function saveCardField(qc: QueryClient, boardId: string, card: Pick<CardSummary, 'id' | 'custom'>, field: Pick<CustomField, 'id' | 'name'>, value: unknown): Promise<void> {
  const expected = card.custom[field.id] ?? null;
  const custom = { ...card.custom };
  if (value === null || value === undefined || value === '') delete custom[field.id];
  else custom[field.id] = value;
  qc.setQueryData<CardDetail>(cardKey(card.id), (d) => (d ? { ...d, custom } : d));
  const sum = qc.getQueryData<BoardSnapshot>(boardKey(boardId))?.cards.find((c) => c.id === card.id);
  if (sum) upsertCards(qc, boardId, [{ ...sum, custom }]);
  try {
    let res: CardDetail | undefined;
    const queued = await sendOrQueue(
      card.id,
      async () => (res = await api.put<CardDetail>(`/api/cards/${card.id}/fields`, { fieldId: field.id, value, opId: newOpId() })),
      { kind: 'field', boardId, cardId: card.id, fieldId: field.id, value, expected },
      `„${field.name}“ geändert`,
    );
    if (!queued && res) upsertCards(qc, boardId, [res]);
  } catch (err) {
    toast.error(`${field.name}: ${(err as Error).message}`);
    void qc.invalidateQueries({ queryKey: cardKey(card.id) });
    void qc.invalidateQueries({ queryKey: boardKey(boardId) });
  }
}
